import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const photo = {
  createPhoto: lazyModuleMethod(() => import('./createPhoto'), 'default'),
}
